import { Pipe, PipeTransform } from '@angular/core';
import { AuthorityService } from '../services/authority.service';

type objectWithAuthority = { [key: string]: any, authorities: string[] };

@Pipe({
  name: 'onlySomeAuthority'
})
export class OnlySomeAuthorityPipe implements PipeTransform {
  transform(objectArray : objectWithAuthority[]): objectWithAuthority[] {
    return objectArray.filter(object => AuthorityService.hasSomeAuthority(object.authorities));
  }
}
